import Vue from 'vue'
import Vuex from 'vuex'
import filterStore from './filters'
import apiStore from './api'
import authStore from './auth'
import selections from './selections'

Vue.use(Vuex)

const initialState = {
  state: {},
  getters: {},
  mutations: {},
  actions: {}
}

/**
 * Defines the independent stores.
 * @type Array
 */
const stores = [filterStore, apiStore, authStore, selections]

/**
 * Accumulates independent stores into a single object to be consumed by vuex.
 * @returns *
 */
const buildStore = () => stores.reduce((acc, curr) => ({
  state: { ...acc.state, ...curr.state },
  getters: { ...acc.getters, ...curr.getters },
  mutations: { ...acc.mutations, ...curr.mutations },
  actions: { ...acc.actions, ...curr.actions }
}), initialState)

export default new Vuex.Store(buildStore())

export { loaders } from './api'
